import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.dispatchEvent(new CustomEvent("admin-campaigns:changed"))
    this.element.remove()
  }
}
